import * as actionTypes from '../../../../Store/Actions/actionTypes';
import axios from '../../../../Axios/axios';

export const getTask =(to)=>{
    return (dispatch) => {
        var SessionIDE = to.Session.Session.SESSION_ID;
        to.ObjParamDto = {};
        to.ObjParamsDto = {};
        to.ObjParamsDto = {
            SessionIDE: SessionIDE,
            ARCS:0,
            Locked:0,
            CD:"",
            SV:0,
            LNH:"ALL",
            ETAT:0,
            RecordFlag:""
        }
        //GET DATA
        axios.ArcsAxios.post("/WCFWindowsArcs/ASKECLoad", to)
        .then(response => {
            dispatch(updateTasksList(response.data));
            
            
        }).catch(error => {
            console.log("ERROR:",error);
        }).finally(res=>{

        });
    
    }
};

export const createTask = () =>{

}

export const removeTask = () =>{

}

export const updateTasksList = (items) =>{
    return {
        type: actionTypes.UPDATE_TASKS,
        data: items
    }
}